// src/config/site.js
// Single source of truth for all site-wide URLs and contact info.

export const SITE = {
  brand: {
    name: "Hayducate",
    tagline:
      "Empowering learners and businesses across Africa with world-class education and hardware — one course, one product at a time.",
  },

  contact: {
    email: "admin@hayducate.com",
    phoneDisplay: "+254 727 880 887",
    phoneRaw: "+254727880887",
    whatsapp: "254727880887",
    location: "Nairobi, Kenya",
    hours: "Mon–Fri, 8:00 – 18:00 EAT",
  },

  social: {
    twitter: "https://x.com/hayducate",
    facebook: "https://facebook.com/hayducate",
    linkedin: "https://linkedin.com/company/hayducate",
    youtube: "https://youtube.com/@hayducate",
    tiktok: "https://tiktok.com/@hayducate",
    whatsapp: "https://wa.me/254727880887",
  },
};

export default SITE;